import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import { Control, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import CustomButton from '../../components/Button';
import { Loader } from '../../components/Loader/Loader';
import LoginModuleWrapper from '../../components/LoginModuleWrapper';
import { TextInput } from '../../components/TextInput';
import { ForgotPasswordI } from '../../utils/interface';
import { pattern } from '../../utils/validationPatterns';
import styles from './ForgotPassword.module.scss';

interface PropsI {
  control: Control<ForgotPasswordI>;
  logoUrl?: string;
  isApiLoading?: boolean;
}

const ForgotPasswordWrapper = ({ control, logoUrl, isApiLoading }: PropsI) => {
  const navigate = useNavigate();

  return (
    <LoginModuleWrapper logoUrl={logoUrl}>
      <div className={styles.formWrapper}>
        <p className={styles.headerText}>Forgot Password?</p>
        <p className={styles.bodyText}>Enter your email, so that we can send your password reset link</p>
        <div className={styles.inputWrapper}>
          <Controller
            name='customerCode'
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                placeholder='Harshberger Enterprises'
                sx={{
                  input: {
                    padding: '16px !important',
                  },
                }}
                disabled
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
          />
          <Controller
            name='email'
            control={control}
            rules={{
              required: 'Email is required',
              validate: value => {
                if (value) {
                  if (!pattern.noSpace.test(value)) {
                    return 'Space is not allowed';
                  }
                  if (!pattern.email.test(value)) {
                    return 'Invalid email address';
                  }
                }
                return undefined;
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                placeholder='Enter your email'
                sx={{
                  input: {
                    padding: '16px !important',
                  },
                }}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
          />
        </div>
        <div className={styles.buttonContainer}>
          <CustomButton
            variant='text'
            sx={{
              color: '#666666 !important',
              fontSize: '14px !important',
              height: '52px !important',
            }}
            onClick={() => navigate('/login')}
          >
            <KeyboardBackspaceRoundedIcon /> Back to Login
          </CustomButton>
          <CustomButton
            type='submit'
            sx={{
              width: '150px',
              fontSize: '14px !important',
              fontWeight: 600,
              height: '52px !important',
            }}
            disabled={isApiLoading}
          >
            Send Email
            {isApiLoading ? <Loader type='button' /> : <ArrowCircleRightOutlinedIcon />}
          </CustomButton>
        </div>
      </div>
    </LoginModuleWrapper>
  );
};

export default ForgotPasswordWrapper;
